export type ActivityType =
  | 'task'
  | 'read'
  | 'watch'
  | 'listen'
  | 'external_link'
  | 'written_reflection'
  | 'upload'
  | 'assessment'
  | 'nlpos_activity'
  | 'ai_chat'
  | 'ai_voice'
  | 'custom';

export type CreatorType = 'coach' | 'partner';
export type AssigneeType = 'coach' | 'respondent';
export type ActivityStatus = 'not_started' | 'in_progress' | 'completed';

export interface Program {
  id: string;
  title: string;
  description: string;
  creatorUserId: string;
  creatorType: CreatorType;
  isSequential: boolean;
  isTemplate: boolean;
  isPublished: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ProgramWithStats extends Program {
  activityCount: number;
  assignmentCount: number;
}

export interface ProgramActivity {
  id: string;
  programId: string;
  position: number;
  activityType: ActivityType;
  title: string;
  instructions: string;
  resourceUrl: string;
  dueDate: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ProgramAssignment {
  id: string;
  programId: string;
  assigneeUserId: string;
  assigneeType: AssigneeType;
  assignedAt: string;
  completedAt: string | null;
  assigneeName?: string;
  assigneeEmail?: string;
}

export interface ProgramActivityProgress {
  id: string;
  assignmentId: string;
  activityId: string;
  status: ActivityStatus;
  startedAt: string | null;
  completedAt: string | null;
}

export interface ProgramActivityResponse {
  id: string;
  progressId: string;
  activityId: string;
  responseText: string;
  uploadPath: string;
  uploadFilename: string;
  createdAt: string;
  updatedAt: string;
}

export interface ProgramDetail extends Program {
  activities: ProgramActivity[];
}

export interface AssignedProgram {
  assignmentId: string;
  program: Program;
  totalActivities: number;
  completedActivities: number;
  currentActivityTitle: string | null;
}

export interface AssigneeOption {
  userId: string;
  name: string;
  email: string;
  type: AssigneeType;
}

export const ACTIVITY_TYPE_LABELS: Record<ActivityType, string> = {
  task: 'Task',
  read: 'Read',
  watch: 'Watch',
  listen: 'Listen',
  external_link: 'External Link',
  written_reflection: 'Written Reflection',
  upload: 'Upload',
  assessment: 'Assessment',
  nlpos_activity: 'NLP OS Activity',
  ai_chat: 'AI Chat',
  ai_voice: 'AI Voice',
  custom: 'Custom Activity',
};

export const ACTIVITY_TYPES: ActivityType[] = [
  'task', 'read', 'watch', 'listen', 'external_link',
  'written_reflection', 'upload', 'assessment',
  'nlpos_activity', 'ai_chat', 'ai_voice', 'custom',
];
